import SignImg from "../image/guidstamp.png";

export default function IMSPolicy() {
  return (
    <div className="p-6 font-[Times_New_Roman,serif] text-[15px] leading-relaxed space-y-4 px-10 mx-5">
      <div className="flex justify-between text-xs">
        <div></div>
        <div className="text-right space-y-1">
          <div><strong>Format no:</strong> AIPL/IMS/IMC/5.2</div>
          <div><strong>Issued on:</strong> 05-10-2020</div>
          <div><strong>Rev. No. & Date:</strong> 01 | 01-08-2023</div>
          <div><strong>Clause No.:</strong> 5.2</div>
        </div>
      </div>

      <h1 className="text-center font-bold text-xl mt-2">
        DYC Global INSPECTIONS PVT. LTD.
      </h1>

      <h2 className="text-center font-bold text-base mt-2 underline">
        IMS-QEHS POLICY
      </h2>

      <p className="italic text-center">
        (Integrated Management System – Quality – Environment – Occupational Health and Safety)
      </p>

      <p>
        We, at DYC Global Inspections Pvt. Ltd., are committed to satisfy both the stated & implied needs and expectations of the relevant interested parties including customers by providing products, processes and services which are of high quality, environmental friendly and safe.
      </p>

      <p className="font-semibold">We strive to,</p>
      <ul className="list-[lower-alpha] pl-6 space-y-1">
        <li>
          Comply with the applicable requirements, compliance obligations and other requirements to which our organisation subscribes.
        </li>
        <li>
          Continual and sustainable improvement of the Integrated Management system (IMS-QEHS) with risk based approach to enhance the organizational performance on QEHS.
        </li>
      </ul>

      <p className="font-semibold">We do commit to prevent,</p>
      <ul className="list-[lower-alpha] pl-6 space-y-1">
        <li>
          The environmental pollution in all our activities, products and services considering a life cycle perspective;
        </li>
        <li>
          The occupational ill-health and injury taking opportunity into consideration.
        </li>
      </ul>

      <p className="font-semibold">We do ensure,</p>
      <ul className="list-[lower-alpha] pl-6 space-y-1">
        <li>
          Protecting the environment relevant to the context of our organisation.
        </li>
        <li>Sustainable resource use.</li>
        <li>Reducing – Reusing and Recycling (R-R-R) of wastage.</li>
        <li>Training for all-round development of our employees.</li>
        <li>
          Providing and maintaining safe, healthy and environmental friendly work places for employee and other relevant interested parties through operational procedures, systems and work methods.
        </li>
      </ul>

      <p>
        In line with this Policy, DYC Global Inspections Pvt. Ltd. does establish IMS-QEHS Objectives for each process, which are appropriate and supporting the purpose, context and strategic direction of the Organization.
      </p>

      <p className="font-semibold">We shall,</p>
      <ul className="list-[lower-alpha] pl-6 space-y-1">
        <li>Communicate and apply this policy within the organisation.</li>
        <li>Make this policy available to the interested parties.</li>
        <li>Review this policy periodically for its relevance and appropriateness.</li>
      </ul>

      <div className="flex justify-between items-end mt-10">
        <div><strong>Date:</strong> 02-08-2024</div>
        <div className="text-right">
          <div className="mt-2 underline">
            <img src={SignImg} />
          </div>
          <div className="font-bold mt-1">
             Ramesh S. Jadhav <br/> CEO & MANAGING DIRECTOR</div>
        </div>
      </div>
    </div>
  );
}
